
export const BraSizeBand: number[] = [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58];

export const BraSizeCup: string[] = [
    'AA',
    'A',
    'B',
    'C',
    'D',
    'DD',
    'DDD',
    'DDDD',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M'
];
